module.exports = __webpack_public_path__ + "img/loginIMG.f343446e.png";